var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specialist-ava-menu sub-menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/specialist-travel"}},[_vm._v("Travel")])],1),_c('li',[_c('router-link',{attrs:{"to":"/specialist-add-travel-receipt"}},[_vm._v("Add Receipt")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }